module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Andrea_480x480.165c081f.mp4";